import { CycleUtils } from './cycle-utils';
const SEARCH_PARAMS = {
  DOMAIN_NAME: 'domainName',
  SITE_GUID: 'siteGuid',
  PRODUCT_ID: 'productId',
  CYCLE_ID: 'cycleId',
  PAYMENT_CYCLE: 'paymentCycle',
  IS_DOWNGRADE_ENABLED: 'isChangePlan',
  REFERRAL_ADDITIONAL_INFO: 'referralAdditionalInfo',
  SHOW_DOMAIN: 'showDomain',
  REFERRER: 'referrer',
  DEBUG: 'debug',
  OVERRIDE_SUBSCRIPTION_ID: 'existingUserPackageGuid',
  SUCCESS_URL: 'successUrl',
  FLOW: 'flow',
  SUB_INDUSTRY: 'subIndustry',
  BUSINESS_SECTOR: 'businessSector',
  BUSINESS_TERM_ID: 'businessTermId',
  APPS: 'apps'
};
const getListParam = (searchParams, key) => {
  const values = (searchParams.get(key) ?? '').split(',').map(value => value.trim()).filter(Boolean);
  return values.length ? values : undefined;
};
export const getSearchParams = () => {
  const searchParams = new URLSearchParams(location.search);
  const domainName = searchParams.get(SEARCH_PARAMS.DOMAIN_NAME) ?? undefined;
  const siteGuid = searchParams.get(SEARCH_PARAMS.SITE_GUID) ?? undefined;
  const productId = searchParams.get(SEARCH_PARAMS.PRODUCT_ID) ?? undefined;
  const cycleId = CycleUtils.validateCycleId(searchParams.get(SEARCH_PARAMS.CYCLE_ID)) ?? undefined;
  const paymentCycle = searchParams.get(SEARCH_PARAMS.PAYMENT_CYCLE) ?? undefined;
  const isDowngradeEnabled = searchParams.get(SEARCH_PARAMS.IS_DOWNGRADE_ENABLED) === 'true';
  const debug = searchParams.get(SEARCH_PARAMS.DEBUG) === 'true';
  const overrideSubscriptionId = searchParams.get(SEARCH_PARAMS.OVERRIDE_SUBSCRIPTION_ID) ?? undefined;
  const referralAdditionalInfo = searchParams.get(SEARCH_PARAMS.REFERRAL_ADDITIONAL_INFO) ?? undefined;
  const showDomain = searchParams.get(SEARCH_PARAMS.SHOW_DOMAIN) === 'true';
  const referrer = searchParams.get(SEARCH_PARAMS.REFERRER) ?? undefined;
  const successUrl = searchParams.get(SEARCH_PARAMS.SUCCESS_URL) ?? undefined;
  const flow = searchParams.get(SEARCH_PARAMS.FLOW) ?? undefined;
  const subIndustry = getListParam(searchParams, SEARCH_PARAMS.SUB_INDUSTRY);
  const businessSector = searchParams.get(SEARCH_PARAMS.BUSINESS_SECTOR) ?? undefined;
  const businessTermId = searchParams.get(SEARCH_PARAMS.BUSINESS_TERM_ID) ?? undefined;
  const apps = getListParam(searchParams, SEARCH_PARAMS.APPS);
  return {
    allSearchParams: searchParams,
    domainName,
    siteGuid,
    productId,
    cycleId,
    paymentCycle,
    referralAdditionalInfo,
    showDomain,
    referrer,
    isDowngradeEnabled,
    debug,
    overrideSubscriptionId,
    successUrl,
    flow,
    subIndustry,
    businessSector,
    businessTermId,
    apps
  };
};
//# sourceMappingURL=getSearchParams.js.map